export enum PaymentStatus {
  Unpaid = 0,
  PartiallyPaid = 1,
  Paid = 2
}

export enum DocumentType {
  Invoice = 0,           // Faktura
  CashReceipt = 1,       // Gotovinski račun
  AdvanceInvoice = 2,    // Avansni račun
  Proforma = 3,          // Profaktura/Predračun
  CreditNote = 4,        // Knjižno odobrenje
  DebitNote = 5          // Knjižno zaduženje
}

export interface PayableDocument {
  id: string;
  supplierId: string;
  supplierName: string;
  supplierNameSnapshot: string;
  documentType: DocumentType;
  invoiceNumber?: string | null;
  deliveryNoteNumber?: string | null;
  invoiceDate?: string | null;
  dueDate?: string | null;
  amount: number;
  paidAmount: number;
  remainingAmount: number;
  referenceNumber?: string | null;
  note?: string | null;
  extraAccountOrDocRef?: string | null;
  paymentCurrency: string;
  paymentExecutionDate?: string | null;
  paymentOrderId?: string | null;
  isOverdue: boolean;
  status: PaymentStatus;
  paidImmediately: boolean;
  paymentAllocations: PayableAllocation[];
  createdAtUtc?: string;
  updatedAtUtc?: string;
}

export interface PayableAllocation {
  id: string;
  paymentId: string;
  allocatedAmount: number;
  paymentDate: string;
  paymentReferenceNumber?: string | null;
  paymentNote?: string | null;
  createdAtUtc: string;
}

export interface CreatePayableDto {
  supplierId: string;
  documentType: DocumentType;
  invoiceNumber?: string | null;
  deliveryNoteNumber?: string | null;
  invoiceDate?: string | null;
  dueDate?: string | null;
  amount: number;
  paidAmount: number;
  referenceNumber?: string | null;
  note?: string | null;
  extraAccountOrDocRef?: string | null;
  paymentCurrency: string;
  paymentExecutionDate?: string | null;
  paymentOrderId?: string | null;
}

export interface UpdatePayableDto extends CreatePayableDto {}

export interface PayableFilter {
  supplierId?: string;
  status?: PaymentStatus;
  overdueOnly?: boolean;
  invoiceDateFrom?: string;
  invoiceDateTo?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  searchText?: string;
  page?: number;
  pageSize?: number;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
